import { COLOR, DATE_FORMAT_CN } from '@/libs/core/constants'
import {
  PageBreak,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  VerticalAlign,
} from 'docx'
import { tableWidthDxa } from '../../constants'
import { pixelToDxa } from '@/libs/utils/docxUtils'
import moment from 'moment'

const Row = ({ label, value, color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) },
    children: [
      new TableCell({
        verticalAlign: VerticalAlign.CENTER,
        shading: { fill: color },
        children: [new Paragraph({ children: label })],
        borders: {
          top: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 0, style: BorderStyle.NONE, color },
          left: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          bottom: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
      new TableCell({
        verticalAlign: VerticalAlign.CENTER,
        shading: { fill: color },
        children: [new Paragraph({ children: value })],
        borders: {
          top: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          left: { size: 0, style: BorderStyle.NONE, color },
          bottom: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
    ],
  })

const DisclaimerPage = ({ reportData }) => {
  const {
    firstPartyAbbreviation,
    firstPartyFullName,
    secondPartyAbbreviation,
    secondPartyFullName,
    version,
    reportDate,
  } = reportData || {}

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph({
      children: [new TextRun({ text: '法律聲明', bold: true })],
    }),
    new Paragraph(''),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun('此分文件內含機密及版權所有的資訊。僅供'),
        new TextRun({
          text: firstPartyAbbreviation,
          color: COLOR.primary,
        }),
        new TextRun('使用。嚴禁未經授權者使用或複製本文件。'),
      ],
    }),
    new Paragraph(''),
    new Paragraph(''),
    new Paragraph({
      children: [
        new TextRun('本測試是由'),
        new TextRun({
          text: secondPartyAbbreviation,
          color: COLOR.primary,
        }),
        new TextRun('的資訊安全專家所執行。'),
        new TextRun({
          text: secondPartyAbbreviation,
          color: COLOR.primary,
        }),
        new TextRun('保證此分文件的內容正確且可經由網路做驗證。'),
      ],
    }),
    new Paragraph(''),
    new Paragraph(''),
    new Paragraph({
      children: [new TextRun({ text: '明關於本⽂', bold: true })],
    }),
    new Paragraph(''),
    new Table({
      columnWidths: [tableWidthDxa / 2, tableWidthDxa / 2],
      width: { size: tableWidthDxa, type: WidthType.DXA },
      rows: [
        Row({
          label: [new TextRun('文件類別')],
          value: [new TextRun('資訊安全教育訓練結果及分析報告書')],
          color: COLOR.secondary_60,
        }),
        Row({
          label: [new TextRun('客戶')],
          value: [new TextRun({ text: firstPartyFullName, color: COLOR.primary })],
        }),
        Row({
          label: [new TextRun('執行顧問')],
          value: [new TextRun({ text: secondPartyFullName, color: COLOR.primary })],
          color: COLOR.secondary_60,
        }),
        Row({
          label: [new TextRun('文件版本')],
          value: [new TextRun({ text: version, color: COLOR.primary })],
        }),
        Row({
          label: [new TextRun('製作日期')],
          value: [
            new TextRun({ text: moment(reportDate).format(DATE_FORMAT_CN), color: COLOR.primary }),
          ],
          color: COLOR.secondary_60,
        }),
      ],
    }),
  ]
}

export default DisclaimerPage
